var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare011(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share-01 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3993 15.2891L3.39722 11.159C3.0302 10.9697 2.72958 10.6731 2.53542 10.3086C2.34127 9.94417 2.26279 9.52919 2.31045 9.119C2.35812 8.70881 2.52966 8.32289 2.80222 8.01266C3.07477 7.70243 3.4354 7.48263 3.83604 7.38255L27.0007 3.89262C27.1792 3.87676 27.3586 3.90832 27.5209 3.98409C27.6833 4.05986 27.8227 4.17717 27.9251 4.32413C28.0275 4.47109 28.0893 4.6425 28.1042 4.82102C28.1192 4.99953 28.0867 5.17882 28.01 5.34073L17.8242 24.8296C17.6242 25.171 17.3289 25.4466 16.9745 25.6225C16.6201 25.7984 16.222 25.867 15.8292 25.8199C15.4363 25.7727 15.0658 25.6119 14.7631 25.3571C14.4604 25.1023 14.2387 24.7647 14.1251 24.3856L11.3993 15.2891Z",
    fill: "#999999"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare011);
export default __webpack_public_path__ + "static/media/share-01 1.b2e9d691ae9f4c504cfe8f879acb18c8.svg";
export { ForwardRef as ReactComponent };